import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import CryptoJS from "crypto-js";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import Axios from "axios";
import { SanitizerRounded } from "@mui/icons-material";
import PaymentRedirectForm from "./PaymentRedirectForm";
import { CREATE_QUOTE_PAGE_ROUTE } from "../../../HealthInsuranceNew/routes";

function PortalRedirectUrl() {
  const { productId } = useParams();
  const [responseData] = useSearchParams();
  let navigate = useNavigate();
  // const [Checksum, setChecksum] = useState({});
  let Checksum;

  const txnId = responseData?.get("txnId");
  const status = responseData?.get("status");
  const kyc_id = responseData?.get("kyc_id");
  const product_id = responseData?.get("product_id");

  // console.log("response arrays: ",responseData?.get("redirectUrl"))

  const productIdArray = productId.split("*");
  const productRef = productIdArray[0];
  const responseId = productIdArray[1];
  const [data, setData] = useState(null);

  let productRef_Hexa = CryptoJS.enc.Hex.parse(productRef);
  let bytesProdRef = productRef_Hexa.toString(CryptoJS.enc.Base64);
  let decryptProduct_Ref = CryptoJS.AES.decrypt(
    bytesProdRef,
    "secret key @123"
  );
  let plainProductRef = decryptProduct_Ref.toString(CryptoJS.enc.Utf8);
  let originalProductRef = plainProductRef.replace(/["]/g, "");

  let responseId_Hexa = CryptoJS.enc.Hex.parse(responseId);
  let bytesResponseId = responseId_Hexa.toString(CryptoJS.enc.Base64);
  let decryptResponseId = CryptoJS.AES.decrypt(
    bytesResponseId,
    "secret key @124"
  );
  let plainResponseId = decryptResponseId.toString(CryptoJS.enc.Utf8);
  let originalResponseId = plainResponseId.replace(/["]/g, "");
  console.log(
    "hh",
    productIdArray,
    plainProductRef,
    typeof plainResponseId,
    originalResponseId
  );

  useEffect(() => {
    if (status === "approved") {
      console.log("Success");
      Swal.fire({
        icon: "success",
        title: `Your CKYC is Approved \n Pehchaan ID: ${kyc_id}`,
        text: "Click on Next button to proceed",
        position: "center",

        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          nextHandler();
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${status}`,
        position: "center",
        showConfirmButton: true,
        confirmButtonText: "Do EKYC",
        showCancelButton: true,
        cancelButtonText: "Re-Enter PAN",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
        } else if (result.dismiss === "cancel") {
        }
        console.log(result, "ff");
      });
    }
  }, []);

  const nextHandler = () => {
    let path = "";
    let encryptedProduct_ref = encodeURIComponent(
      CryptoJS.AES.encrypt(
        JSON.stringify(originalProductRef),
        "secret key @123"
      ).toString()
    );
    let encryptedDataId = encodeURIComponent(
      CryptoJS.AES.encrypt(
        JSON.stringify(originalResponseId),
        "secret key @124"
      ).toString()
    );

    let Acuvisor_product_id = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(product_id), 'secret key @124').toString());

   
    // let domain = "";
    // if (window.location.hostname === "localhost") {
    //   domain = process.env.REACT_APP_LOCAL_DJANGO;
    // } else if (window.location.hostname.trim() === "acuvisor.com") {
    //   domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    // } else {
    //   domain = process.env.REACT_APP_UAT_DJANGO;
    // }

    // Axios.post(`${domain}/api/hdfc-payment/${String(originalProductRef)}/${String(originalResponseId)}/${String(kyc_id)}/`)
    //   .then((response) => {
    //     if (response.status === 200) {
    //       console.log("Get Checksum", response.data);
    //       Checksum = response.data;
    if(product_id === "31072023"){
      navigate(`${CREATE_QUOTE_PAGE_ROUTE}/${encryptedDataId}/${Acuvisor_product_id}`);
    }

          // navigate(`/health-insurance/product-stastus/${originalResponseId}`,
          //  {
          //   state: {
          //     checksum: Checksum,
          //     refid: originalProductRef,
          //     resid: originalResponseId,
          //   },
          // }
          // );
      //     // PaymentRedirectForm(Checksum);
      //   }
      // })
      // .catch((e) => {
      //   alert(e);
      // });

    // path = `/health-insurance/product/${encryptedProduct_ref}*${encryptedDataId}`;
    // navigate(path);
  };

  return (
    <div>
      <div>
        <div>Loading...</div>
      </div>
    </div>
  );
}

export default PortalRedirectUrl;
